import { getCount } from "./helper";
import UserDeleteWarning from "./warnings/UserDeleteWarning";
import GardenerResourceWarning from "./warnings/GardenerResourceWarning";
import RotateKubeConfigWarning from "./warnings/RotateKubeConfigWarning";
import { ConfirmBoxType } from "../reducer/type";
import { useMemo } from "react";

type DescriptionProps = Pick<
  ConfirmBoxType,
  "entity" | "operation" | "resources"
>;

const ResourceRow = ({
  resource,
}: {
  resource: { [key: string]: unknown };
}) => {
  const metadata = resource.metadata as { name?: string } | undefined;

  return (
    <li>
      {resource?.region && `[${resource.region}]`}
      {(resource?.name || metadata?.name) && " name: "}
      {resource?.name || metadata?.name}
      {resource?.id && ` (${resource.id})`}
    </li>
  );
};

const Description = ({ entity, operation, resources }: DescriptionProps) => {
  const showWarnings = useMemo(
    () => ({
      deleteUser:
        operation === "delete" &&
        (entity === "cleura user" || entity === "openstack user"),
      rotateKubeConfig: operation === "rotate kubeconfig",
    }),
    [entity, operation],
  );

  if (!resources) return null;

  const count = getCount(resources);
  return (
    <div className="padding-bottom-20 min-height-150">
      <p>
        {count > 1 ? "These" : "This"} {entity}
        {count > 1 && "s"} will be affected:
      </p>
      <ul>
        {Array.isArray(resources) ? (
          resources.map((x, key) => <ResourceRow key={key} resource={x} />)
        ) : (
          <ResourceRow resource={resources} />
        )}
      </ul>

      {showWarnings.deleteUser && <UserDeleteWarning />}

      <GardenerResourceWarning resources={resources} entity={entity} />

      {showWarnings.rotateKubeConfig && <RotateKubeConfigWarning />}

      <p>Are you sure?</p>
    </div>
  );
};

export default Description;
